import React, { useEffect, useState } from 'react';
import { db, auth } from '../serices/firebase';
import { collection, onSnapshot, doc, updateDoc, deleteDoc, query, orderBy } from 'firebase/firestore';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { 
  Menu, X, CheckCircle, XCircle, LogOut, LayoutDashboard,
  Eye, MessageSquare, Instagram, Youtube, Phone, Mail, MapPin, Music2,
  Trophy, BarChart3, Layers, Zap, TrendingUp, Globe, ExternalLink, Heart
} from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import CategoryManager from '../components/CategoryManager';
import SponsorManager from '../components/SponsorManager';
import DispatchConsole from '../components/DispatchConsole';
//import NomineeQRGenerator from '../components/NomineeQRGenerator';

const Admin = () => {
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('overview'); 
  const [nominations, setNominations] = useState([]);
  const [selectedNominee, setSelectedNominee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
  const navigate = useNavigate();

  // 1. AUTH PROTECTION
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) navigate('/admin-login');
      else setUser(currentUser);
    });
    return () => unsubscribe();
  }, [navigate]);

  // 2. REAL-TIME DATA FETCHING
  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "nominations"), (snapshot) => {
      const docs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNominations(docs);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // --- HELPERS & CALCULATION ---
  const getGroupedData = (status) => {
    return nominations
      .filter(n => n.status === status)
      .reduce((acc, nominee) => {
        const cat = nominee.category || "Uncategorized";
        if (!acc[cat]) acc[cat] = [];
        acc[cat].push(nominee);
        return acc;
      }, {});
  };

  const totalVotes = nominations.reduce((acc, curr) => acc + (curr.voteCount || 0), 0);
  const totalRevenue = totalVotes * 10; 

  // --- ACTION HANDLERS ---
  const handleApprove = async (id) => {
    try {
        await updateDoc(doc(db, "nominations", id), { status: 'approved' });
        setSelectedNominee(null);
    } catch (err) { alert("Error approving: " + err.message); }
  };

  const handleReject = async (id) => {
    if (window.confirm("Permanently delete this nomination? This cannot be undone.")) {
      try {
          await deleteDoc(doc(db, "nominations", id));
          setSelectedNominee(null);
      } catch (err) { alert("Error deleting: " + err.message); }
    }
  };

  /*const sendNotification = (n) => {
    const message = `Congratulations ${n.name}! Your nomination for MZINYI TALENT AWARDS 2026 has been APPROVED. %0A%0AOfficial Voting Link: https://mzinyitaitatavetaawards.netlify.app/vote/${n.slug}`;
    window.open(`https://wa.me/${n.phone.replace(/[^0-9]/g, '')}?text=${message}`, '_blank');
  };*/

  // --- UPDATE THIS FUNCTION IN Admin.jsx ---
/*const sendNotification = (n) => {
  // 1. Clean the phone number (remove spaces, plus signs, and non-numeric chars)
  let cleanedPhone = n.phone.replace(/[^0-9]/g, '');

  // 2. Logic to ensure Kenyan Country Code (254)
  // If it starts with 07... or 01..., replace the 0 with 254
  if (cleanedPhone.startsWith('0')) {
    cleanedPhone = '254' + cleanedPhone.substring(1);
  } 
  // If it starts with 7... or 1... (missing the 0), add 254 to the front
  else if (cleanedPhone.startsWith('7') || cleanedPhone.startsWith('1')) {
    cleanedPhone = '254' + cleanedPhone;
  }

 // const message = `Congratulations ${n.name}! %0A%0AYour nomination for the MZINYI TALENT AWARDS 2026 has been APPROVED. %0A%0AOfficial Voting Link: https://mzinyitaitatavetaawards.netlify.app/vote/${n.slug}`;

 const message = `🌟 *CONGRATULATIONS ${n.name.toUpperCase()}!* 🌟%0A%0A` +
`Your nomination for the *MZINYI TALENT AWARDS 2026* has been officially *APPROVED!* 🏆%0A%0A` +
`🔗 *Your Official Voting Link:* %0Ahttps://mzinyitaitatavetaawards.netlify.app/vote/${n.slug}%0A%0A` +
`🔥 *WHAT TO DO NEXT:*%0A` +
`1. *Mobilize:* Start preparing your fans and followers right now! %0A` +
`2. *Market:* Share your voting link on your Instagram Bio, TikTok, and WhatsApp Status. %0A` +
`3. *Campaign:* Create posters and videos telling people why they should vote for you. %0A%0A` +
`📅 *VOTING PERIOD:* %0AOfficial voting begins on *April 9th*.%0A%0A` +
`Success favors the most active—start your marketing today! 🚀`;
  
  // Use the fixed cleanedPhone
  window.open(`https://wa.me/${cleanedPhone}?text=${message}`, '_blank');
};*/

/*const sendNotification = (n) => {
  // 1. Clean the phone number (Keep your existing logic)
  let cleanedPhone = n.phone.replace(/[^0-9]/g, '');

  // 2. Logic to ensure Kenyan Country Code (Keep your existing logic)
  if (cleanedPhone.startsWith('0')) {
    cleanedPhone = '254' + cleanedPhone.substring(1);
  } 
  else if (cleanedPhone.startsWith('7') || cleanedPhone.startsWith('1')) {
    cleanedPhone = '254' + cleanedPhone;
  }

  // 3. Updated Message with Hype Challenge & Bonus Info
  const messageText = `🔥 *CHALLENGE ALERT: CLAIM +50 BONUS VOTES!* 🔥
  
  🌟 *CONGRATULATIONS ${n.name.toUpperCase()}!* 🌟

Good news from *MZINYI TAITA TAVETA AWARDS 2026*! 🏆

🔗 *Your Official Voting Link:* 
https://mzinyitaitatavetaawards.netlify.app/vote/${n.slug}

🔥 *THE #MZINYIBONUS CHALLENGE:*
To help you reach the top, we are giving away *50 BONUS VOTES*!
1. *Record a Video:* Make a 30-60s video showcasing your talent or asking for votes.
2. *Post & Tag:* Upload it to TikTok, Instagram, and Facebook Status.
3. *Include Link:* You MUST put your voting link (above) in the caption or bio.
4. *Tag Us:* Use hashtag #Mzinyi talent Awards on facebook.
5. *To Win:* Send a screenshot of your video 'Insights/Analytics' showing your total shares to this number by Friday 10 PM. Decisions are final.

🎁 *THE REWARD:*
The most viral/shared video by *Friday 10:00 PM* wins *50 BONUS VOTES* added to their official tally! 🚀

📅 *VOTING DEADLINE:* May 25th
✨ *GRAND GALA NIGHT:* May 30th

Success favors the loudest—start your video campaign today! ⚡`;

  // 4. Encode and Open
  const encodedMessage = encodeURIComponent(messageText);
  window.open(`https://wa.me/${cleanedPhone}?text=${encodedMessage}`, '_blank');
};*/

/*const sendNotification = (n) => {
  // 1. Clean the phone number (Keep your existing logic)
  let cleanedPhone = n.phone.replace(/[^0-9]/g, '');
  if (cleanedPhone.startsWith('0')) {
    cleanedPhone = '254' + cleanedPhone.substring(1);
  } 
  else if (cleanedPhone.startsWith('7') || cleanedPhone.startsWith('1')) {
    cleanedPhone = '254' + cleanedPhone;
  }

  // 2. The Final Call Message logic
  const messageText = `🚨 *CHALLENGE CALL: FEW HOURS REMAINING! (+50 BONUS)* 🚨

Legends, the *#MZINYI +50 BONUS CHALLENGE* ends tonight at *10:00 PM SHARP!* 🕛

✅ *ALREADY SUBMITTED?*
For those who have already sent their screenshots: *WE HAVE SEEN YOU!* 🔥 Your entries are currently being audited. Great effort!

❌ *NOT SUBMITTED YET?*
For those who haven't: *WHAT ARE YOU WAITING FOR?* This is your last chance to secure *+50 BONUS VOTES* and leapfrog your competition! 🚀

📸 *REMINDER TO QUALIFY:*
You MUST send a screenshot of your video "Insights/Analytics" showing your total shares/engagement to this number before the 10:00 PM deadline.

🏆 *THE PRIZE:* +50 Votes *courtesy of MZINYI TAITA TAVETA AWARDS*.
🔗 *VOTING LINK:* https://mzinyitaitatavetaawards.netlify.app/vote/${n.slug}

Don't let 50 votes slip away—it could be the difference between winning and losing at *The Avid Hotel*! ⚡️

*MZINYI TAITA TAVETA AWARDS 2026*`;

  // 3. Encode and Open
  const encodedMessage = encodeURIComponent(messageText);
  window.open(`https://wa.me/${cleanedPhone}?text=${encodedMessage}`, '_blank');
};*/

const sendNotification = (n) => {
  // 1. Clean the phone number
  let cleanedPhone = n.phone.replace(/[^0-9]/g, '');

  if (cleanedPhone.startsWith('0')) {
    cleanedPhone = '254' + cleanedPhone.substring(1);
  } 
  else if (
    cleanedPhone.startsWith('7') ||
    cleanedPhone.startsWith('1')
  ) {
    cleanedPhone = '254' + cleanedPhone;
  }


// 2. Final Voting Countdown Message
/*const messageText = `🎉 *OFFICIAL GRAND GALA INVITATION – MZINYI TAITA TAVETA AWARDS 2026* 🏆✨

Dear Nominee,

Congratulations once again on your participation for the *MZINYI TAITA TAVETA AWARDS SEASON 1!* 👏🔥

Voting has officially closed, and we are excited to officially invite you to attend the *Grand Finale & Award Gala Night* as we celebrate excellence, talent, and impact across Taita Taveta County. 🌟

📅 *Date:* 30th May 2026  
📍 *Venue:* The Avid Hotel, Voi  
🕔 *Time:* 5:00 PM – 11:00 PM  

⏰ *Please arrive on time* to allow smooth entry and seating before the main program begins.

🎭 *DRESS CODE:* BLACK & GOLD  
All nominees are encouraged to attend dressed elegantly in line with the theme. ✨

👥 *Come with your friends, fans, supporters, and team members* as we celebrate this special moment together and make the night unforgettable! 🔥

🎟️ *ENTRY:* FREE FOR ALL ATTENDEES

This will be a prestigious evening filled with entertainment, recognition, networking, media coverage, and unforgettable moments. 🏆🎶📸

Thank you for being part of this historic first edition of the awards. We look forward to celebrating with you!

*MZINYI TAITA TAVETA AWARDS 2026* 🏆`;*/

const messageText = `🎉 *THANK YOU FROM MZINYI TAITA TAVETA AWARDS 2026* 🏆

Dear Nominee,

On behalf of the Mzinyi Taita Taveta Awards team, we would like to sincerely thank you for being part of the historic first edition of the awards.

We truly appreciate the time, effort, and passion you put into your journey throughout the awards season. Whether you won an award or not, your impact and dedication continue to inspire our community. 🌟

📸 *Event Photos:*
Download and view all gala photos here:
https://photos.app.goo.gl/ksowamuSnFEJqoUC8

👍 *Follow Our Facebook Page:*
Stay connected for updates, announcements, and future opportunities:
*Mzinyi talents Awards*

💬 *Join Our WhatsApp Community:*
For updates, networking, support, and any assistance you may need:
https://chat.whatsapp.com/Cvgmfw3pn0b2InROGLanqR

Thank you once again for being part of the Mzinyi Taita Taveta Awards family. We look forward to growing together and celebrating even greater achievements in the future.

With appreciation,

🏆 *MZINYI TAITA TAVETA AWARDS TEAM*`;

  // 3. Encode and Open WhatsApp
  const encodedMessage = encodeURIComponent(messageText);

  window.open(
    `https://wa.me/${cleanedPhone}?text=${encodedMessage}`,
    '_blank'
  );
};

  const navItems = [
    { id: 'overview', name: 'Overview', icon: <LayoutDashboard size={18}/> },
    { id: 'pending', name: 'Approvals', icon: <Eye size={18}/>, badge: nominations.filter(x => x.status === 'pending').length },
    { id: 'approved', name: 'Active Nominees', icon: <CheckCircle size={18}/> },
    { id: 'polls', name: 'Poll Counts', icon: <TrendingUp size={18}/> },
    { id: 'categories', name: 'Categories', icon: <Layers size={18}/> },
    { id: 'sponsors', name: 'Sponsors', icon: <Heart size={18}/> },
  ];

  if (loading) return (
    <div className="h-screen bg-black flex flex-col items-center justify-center space-y-4">
      <Zap className="text-[#D4AF37] animate-bounce" size={48} />
      <p className="text-[#D4AF37] font-black uppercase tracking-[0.4em] text-xs">Securing Admin Session</p>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col md:flex-row font-sans overflow-hidden">
      
      {/* --- MOBILE NAV HEADER --- */}
      <div className="md:hidden bg-black/95 backdrop-blur-md p-5 flex justify-between items-center border-b border-white/5 sticky top-0 z-[100]">
        <div className="text-lg font-black italic text-[#D4AF37] tracking-tighter">MZINYI <span className="text-white">ADMIN</span></div>
        <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="p-2 bg-[#D4AF37] text-black rounded-lg">
          {isSidebarOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* --- SIDEBAR NAVIGATION --- */}
      <aside className={`
        fixed inset-y-0 left-0 z-[90] w-72 bg-black border-r border-white/5 flex flex-col p-6 transform transition-transform duration-500 ease-in-out
        ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
        md:relative md:translate-x-0
      `}>
        <div className="hidden md:block mb-12 px-2">
            <h1 className="text-2xl font-black italic text-[#D4AF37] leading-none uppercase">Mzinyi</h1>
            <p className="text-[9px] font-black tracking-[0.5em] text-white/30 uppercase mt-1">Authorized Console</p>
        </div>
        
        <nav className="flex-1 space-y-2">
          {navItems.map((item) => (
            <button 
              key={item.id}
              onClick={() => { setActiveTab(item.id); setIsSidebarOpen(false); }} 
              className={`w-full flex items-center justify-between p-4 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all duration-300 ${activeTab === item.id ? 'bg-[#D4AF37] text-black shadow-lg shadow-[#D4AF37]/20' : 'hover:bg-white/5 text-white/40'}`}
            >
              <div className="flex items-center gap-4">{item.icon} {item.name}</div>
              {item.badge > 0 && <span className={`px-2 py-0.5 rounded-full text-[8px] ${activeTab === item.id ? 'bg-black text-white' : 'bg-red-600 text-white animate-pulse'}`}>{item.badge}</span>}
            </button>
          ))}
        </nav>

        <button onClick={() => signOut(auth)} className="mt-auto text-white/20 p-4 flex items-center gap-3 hover:text-red-500 uppercase text-[9px] font-bold border-t border-white/5 transition-colors">
          <LogOut size={16}/> Terminate Session
        </button>
      </aside>

      {/* --- OVERLAY FOR MOBILE --- */}
      <AnimatePresence>
        {isSidebarOpen && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setIsSidebarOpen(false)} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[80] md:hidden" />
        )}
      </AnimatePresence>

      {/* --- MAIN DISPLAY AREA --- */}
      <main className="flex-1 p-6 md:p-12 lg:p-16 h-screen overflow-y-auto w-full custom-scrollbar">
        
        {/* VIEW 1: OVERVIEW */}
        {activeTab === 'overview' && (
          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
             <h2 className="text-4xl font-black uppercase italic mb-10 tracking-tighter">System <span className="text-[#D4AF37]">Overview</span></h2>
             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                <div className="bg-zinc-900/50 border border-white/5 p-8 rounded-3xl group hover:border-[#D4AF37]/30 transition-all">
                   <div className="text-[#D4AF37] mb-4"><BarChart3 size={24}/></div>
                   <p className="text-[10px] font-black text-white/40 uppercase tracking-widest mb-1">Est. Gross Revenue</p>
                   <p className="text-4xl font-black italic">KES {totalRevenue.toLocaleString()}</p>
                </div>
                <div className="bg-zinc-900/50 border border-white/5 p-8 rounded-3xl group hover:border-[#D4AF37]/30 transition-all">
                   <div className="text-[#D4AF37] mb-4"><Zap size={24}/></div>
                   <p className="text-[10px] font-black text-white/40 uppercase tracking-widest mb-1">Verified Votes</p>
                   <p className="text-4xl font-black italic">{totalVotes.toLocaleString()}</p>
                </div>
                <div className="bg-zinc-900/50 border border-white/5 p-8 rounded-3xl group hover:border-[#D4AF37]/30 transition-all">
                   <div className="text-[#D4AF37] mb-4"><Trophy size={24}/></div>
                   <p className="text-[10px] font-black text-white/40 uppercase tracking-widest mb-1">Active Nominees</p>
                   <p className="text-4xl font-black italic">{nominations.filter(x => x.status === 'approved').length}</p>
                </div>
             </div>
          </motion.div>
        )}

        {/* VIEW 2: POLL COUNTS (LEADERBOARD) */}
        {activeTab === 'polls' && (
           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <h2 className="text-4xl font-black uppercase italic mb-10 tracking-tighter text-[#D4AF37]">Live Polls</h2>
              <div className="space-y-10">
                {Object.entries(getGroupedData('approved')).length === 0 ? (
                    <p className="text-white/20 uppercase font-black tracking-widest text-center py-20 border border-dashed border-white/5 rounded-3xl">No approved nominees to rank yet.</p>
                ) : (
                    Object.entries(getGroupedData('approved')).map(([category, people]) => (
                    <div key={category} className="bg-zinc-900/20 p-8 rounded-3xl border border-white/5">
                        <h3 className="text-xs font-black uppercase tracking-[0.4em] mb-8 text-[#D4AF37] flex items-center gap-4">
                            <div className="h-px w-8 bg-[#D4AF37]/30" /> {category}
                        </h3>
                        <div className="space-y-4">
                        {people.sort((a,b) => b.voteCount - a.voteCount).map((p, index) => (
                            <div key={p.id} className="flex items-center justify-between p-5 bg-black/40 rounded-2xl border border-white/5 hover:border-[#D4AF37]/20 transition-all group">
                            <div className="flex items-center gap-6">
                                <span className={`text-xl font-black italic ${index === 0 ? 'text-[#D4AF37]' : 'text-white/10'}`}>#{index + 1}</span>
                                <img src={p.imageUrl} className="w-10 h-10 rounded-full object-cover grayscale group-hover:grayscale-0" alt="rank" />
                                <p className="font-black text-sm uppercase tracking-tight">{p.name}</p>
                            </div>
                            <div className="text-right">
                                <p className="text-[#D4AF37] font-black text-xl italic leading-none">{p.voteCount || 0}</p>
                                <p className="text-[8px] text-white/30 uppercase font-bold tracking-widest mt-1">Votes</p>
                            </div>
                            </div>
                        ))}
                        </div>
                    </div>
                    ))
                )}
              </div>
           </motion.div>
        )}

        {/* VIEW 3: APPROVAL QUEUE & ACTIVE LIST */}
        {(activeTab === 'pending' || activeTab === 'approved') && (
           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <h2 className="text-4xl font-black uppercase italic mb-10 tracking-tighter">
                {activeTab === 'pending' ? 'Verification' : 'Active'} <span className="text-[#D4AF37]">Roster</span>
              </h2>
              {Object.keys(getGroupedData(activeTab)).length === 0 ? (
                <div className="text-center py-20 bg-zinc-900/10 rounded-3xl border border-dashed border-white/5">
                    <p className="text-white/20 uppercase font-black tracking-widest text-xs italic">Queue is currently empty</p>
                </div>
              ) : (
                Object.entries(getGroupedData(activeTab)).map(([category, items]) => (
                  <div key={category} className="mb-12">
                    <div className="flex items-center gap-4 mb-6 italic"><h3 className="text-[#D4AF37] text-[11px] font-black uppercase tracking-[0.4em]">{category}</h3><div className="h-[1px] flex-grow bg-white/5"/></div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                      {items.map(n => (
                        <div key={n.id} className="bg-zinc-900/40 border border-white/5 p-5 rounded-2xl flex items-center justify-between group hover:border-[#D4AF37]/30 transition-all">
                          <div className="flex items-center gap-4 truncate">
                             <img src={n.imageUrl} className="w-14 h-14 rounded-xl object-cover grayscale group-hover:grayscale-0 transition-all border border-white/5" alt="thumb" />
                             <div className="truncate">
                                <p className="font-black text-xs uppercase truncate mb-1">{n.name}</p>
                                <p className="text-[9px] text-white/30 uppercase font-bold tracking-widest">{n.county}</p>
                             </div>
                          </div>
                          <button onClick={() => setSelectedNominee(n)} className="bg-white/5 hover:bg-[#D4AF37] hover:text-black p-3 rounded-xl transition-all shadow-lg shadow-black/50"><Eye size={18}/></button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              )}
           </motion.div>
        )}

        {/* VIEW 4: CATEGORIES */}
        {/*activeTab === 'categories' && (
           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <h2 className="text-4xl font-black uppercase italic mb-10 tracking-tighter">System <span className="text-[#D4AF37]">Categories</span></h2>
              <div className="bg-zinc-900/30 p-12 rounded-[2.5rem] border border-white/5 text-center backdrop-blur-md">
                 <p className="text-white/40 uppercase font-black text-[10px] tracking-[0.4em] mb-10">Currently accepting nominations for:</p>
                 <div className="flex flex-wrap justify-center gap-4">
                   {["Musician", "Influencer", "Dancer", "MC / Host", "Content Creator", "Business / Brand"].map(c => (
                     <div key={c} className="px-8 py-4 bg-black border border-white/10 rounded-2xl text-[11px] font-black uppercase tracking-widest text-[#D4AF37] shadow-xl">{c}</div>
                   ))}
                 </div>
              </div>
           </motion.div>
        )*/}
        {activeTab === 'categories' && (
   <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <h2 className="text-4xl font-black uppercase italic mb-10 tracking-tighter">
         Manage <span className="text-[#D4AF37]">Categories</span>
      </h2>
      
      {/* 1. CALL THE NEW COMPONENT HERE */}
      <CategoryManager />
      
   </motion.div>
)}
{/* VIEW 5: SPONSORS */}
{activeTab === 'sponsors' && (
   <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <h2 className="text-4xl font-black uppercase italic mb-10 tracking-tighter">
         Official <span className="text-[#D4AF37]">Partners</span>
      </h2>
      <SponsorManager />
   </motion.div>
)}

      </main>

      {/* --- SCROLLABLE DETAIL MODAL --- */}
      <AnimatePresence>
        {selectedNominee && (
          <div className="fixed inset-0 z-[200] flex items-end md:items-center justify-center p-0 md:p-6">
            {/* Backdrop */}
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setSelectedNominee(null)} className="absolute inset-0 bg-black/95 backdrop-blur-xl" />
            
            {/* Modal Body */}
            <motion.div 
              initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }}
              transition={{ type: "spring", damping: 30, stiffness: 300 }}
              className="bg-zinc-950 border-t md:border border-white/10 w-full max-w-2xl rounded-t-[2.5rem] md:rounded-[2.5rem] overflow-hidden relative z-10 max-h-[94vh] flex flex-col shadow-[0_-20px_50px_rgba(0,0,0,0.5)]"
            >
              {/* Image Header */}
              <div className="relative h-64 flex-shrink-0 group">
                <img src={selectedNominee.imageUrl} className="w-full h-full object-cover" alt="nominee" />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent" />
                <button onClick={() => setSelectedNominee(null)} className="absolute top-6 right-6 bg-black/50 hover:bg-[#D4AF37] text-white hover:text-black p-3 rounded-full transition-all duration-300">
                  <X size={20}/>
                </button>
              </div>
              
              {/* Content (Scrollable) */}
              <div className="p-8 md:p-12 overflow-y-auto custom-scrollbar">
                <div className="mb-10">
                  <span className="bg-[#D4AF37] text-black px-4 py-1.5 font-black text-[9px] uppercase tracking-[0.3em] rounded-full inline-block mb-4 italic">
                    {selectedNominee.category}
                  </span>
                  <h2 className="text-4xl md:text-6xl font-black uppercase italic text-white leading-none tracking-tighter">
                    {selectedNominee.name}
                  </h2>
                </div>

                {/* Info Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 border-y border-white/5 py-10">
                  <div className="space-y-5">
                    <p className="text-[10px] font-black text-[#D4AF37] uppercase tracking-[0.3em] italic">Identification</p>
                    <div className="flex items-center gap-4 text-white/60 text-[11px] font-bold uppercase"><Phone size={16} className="text-[#D4AF37]"/> {selectedNominee.phone}</div>
                    <div className="flex items-center gap-4 text-white/60 text-[11px] font-bold uppercase"><Mail size={16} className="text-[#D4AF37]"/> {selectedNominee.email}</div>
                    <div className="flex items-center gap-4 text-white/60 text-[11px] font-bold uppercase"><MapPin size={16} className="text-[#D4AF37]"/> {selectedNominee.county}</div>
                  </div>

                  <div className="space-y-5">
                    <p className="text-[10px] font-black text-[#D4AF37] uppercase tracking-[0.3em] italic">Social Evidence</p>
                    <div className="flex flex-col gap-3">
                      {selectedNominee.socials?.instagram ? (
                        <a href={selectedNominee.socials.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/40 hover:text-[#D4AF37] transition-all text-[10px] font-black uppercase tracking-widest"><Instagram size={18}/> View Instagram <ExternalLink size={10}/></a>
                      ) : <p className="text-white/10 text-[10px] uppercase font-bold">No Instagram</p>}
                      {selectedNominee.socials?.tiktok && (
                        <a href={selectedNominee.socials.tiktok} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/40 hover:text-[#D4AF37] transition-all text-[10px] font-black uppercase tracking-widest"><Music2 size={18}/> View TikTok <ExternalLink size={10}/></a>
                      )}
                      {selectedNominee.socials?.youtube && (
                        <a href={selectedNominee.socials.youtube} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/40 hover:text-[#D4AF37] transition-all text-[10px] font-black uppercase tracking-widest"><Youtube size={18}/> View Youtube <ExternalLink size={10}/></a>
                      )}
                    </div>
                  </div>
                </div>

                {/* Biography Section */}
                {/*<div className="space-y-6 mb-12">
                   <div className="p-8 bg-zinc-900 border border-white/5 rounded-[2rem] shadow-inner relative overflow-hidden">
                      <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.4em] mb-6 italic border-b border-[#D4AF37]/20 pb-4">Nomination Narrative</p>
                      <p className="text-white/70 text-sm leading-relaxed whitespace-pre-wrap italic font-light">"{selectedNominee.reason}"</p>
                      
                      {selectedNominee.achievements && (
                        <div className="mt-10 pt-8 border-t border-white/5">
                            <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.3em] mb-4">Core Achievements</p>
                            <p className="text-white/70 text-sm leading-relaxed">{selectedNominee.achievements}</p>
                        </div>
                      )}
                   </div>
                </div>

                {/* Footer Actions *//*
                <div className="flex flex-col md:flex-row gap-4 sticky bottom-0 bg-zinc-950 pt-6 pb-2 border-t border-white/5 mt-4">
                   {selectedNominee.status === 'pending' ? (
                     <button onClick={() => handleApprove(selectedNominee.id)} className="flex-1 bg-[#D4AF37] text-black py-6 font-black uppercase tracking-[0.4em] text-xs rounded-2xl shadow-2xl hover:bg-white transition-all duration-500">Approve Entry</button>
                   ) : (
                     <button onClick={() => sendNotification(selectedNominee)} className="flex-1 bg-green-600 text-white py-6 font-black uppercase tracking-[0.4em] text-xs rounded-2xl flex items-center justify-center gap-3 hover:bg-green-500 transition-all"><MessageSquare size={20}/> Notify via WhatsApp</button>
                   )}
                   <button onClick={() => handleReject(selectedNominee.id)} className="w-full md:w-20 flex items-center justify-center border border-red-500/20 text-red-500 rounded-2xl py-6 hover:bg-red-500 hover:text-white transition-all"><XCircle size={24}/></button>
                </div>
              </div>*/}
              {/* Biography Section */}
                <div className="space-y-6 mb-12">
                   <div className="p-8 bg-zinc-900 border border-white/5 rounded-[2rem] shadow-inner relative overflow-hidden">
                      <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.4em] mb-6 italic border-b border-[#D4AF37]/20 pb-4">Nomination Narrative</p>
                      <p className="text-white/70 text-sm leading-relaxed whitespace-pre-wrap italic font-light">"{selectedNominee.reason}"</p>
                      
                      {selectedNominee.achievements && (
                        <div className="mt-10 pt-8 border-t border-white/5">
                            <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.3em] mb-4">Core Achievements</p>
                            <p className="text-white/70 text-sm leading-relaxed">{selectedNominee.achievements}</p>
                        </div>
                      )}
                   </div>

                   {/* --- INTEGRATED DISPATCH CONSOLE --- */}
                   {/* This appears only for active nominees to manage their campaign material */}
                   {selectedNominee.status === 'approved' && (
                    <div className="space-y-4">
                     <DispatchConsole 
                        nominee={selectedNominee} 
                        onWhatsApp={sendNotification} 
                     />
                     {/*<NomineeQRGenerator nominee={selectedNominee} />*/}
                     </div>
                   )}
                </div>

                {/* Footer Actions */}
               <div className="flex flex-col md:flex-row gap-4 sticky bottom-0 bg-zinc-950 pt-6 pb-2 border-t border-white/5 mt-4">
                   {selectedNominee.status === 'pending' ? (
                     <button 
                        onClick={() => handleApprove(selectedNominee.id)} 
                        className="flex-1 bg-[#D4AF37] text-black py-6 font-black uppercase tracking-[0.4em] text-xs rounded-2xl shadow-2xl hover:bg-white transition-all duration-500"
                      >
                        Approve Entry
                      </button>
                   ) : (
                     
                     <div className="flex-1 flex items-center justify-center">
                        <span className="text-[9px] font-black uppercase text-white/20 tracking-[0.4em] italic">
                          Dispatch Controls Active Above
                        </span>
                     </div>
                   )}
                   
                   <button 
                      onClick={() => handleReject(selectedNominee.id)} 
                      className="w-full md:w-20 flex items-center justify-center border border-red-500/20 text-red-500 rounded-2xl py-6 hover:bg-red-500 hover:text-white transition-all"
                    >
                      <XCircle size={24}/>
                   </button>
                </div>
                
                </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* --- GLOBAL CSS FOR SCROLLBARS --- */}
      <style dangerouslySetInnerHTML={{ __html: `
        .custom-scrollbar::-webkit-scrollbar { width: 3px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #D4AF37; border-radius: 10px; }
      `}} />

    </div>
  );
};

export default Admin;